<template>
  <div class="feedback-page">
    <!-- Header -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo" @click="goHome">
          <span class="logo-text">51软件下载</span>
        </div>
        <el-menu 
          mode="horizontal" 
          class="nav-menu" 
          background-color="transparent" 
          text-color="#1890ff"
          active-text-color="#1890ff"
          :default-active="activeMenu"
          @select="handleMenuSelect"
          :ellipsis="false"
        >
          <el-menu-item index="/" >首页</el-menu-item>
          <el-menu-item index="/order-query">订单查询</el-menu-item>
          <!-- <el-menu-item index="/about">关于我们</el-menu-item> -->
          <el-menu-item index="/feedback" :style="{ color: '#666' }">意见反馈</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- Main Content -->
    <div class="feedback-container">
      <div class="feedback-card">
        <div class="feedback-header">
          <h1 class="feedback-title">意见反馈</h1>
          <p class="feedback-subtitle">我们重视您的每一个建议和意见</p>
        </div>

        <el-form 
          ref="feedbackFormRef" 
          :model="feedbackForm" 
          :rules="rules" 
          label-width="80px"
          class="feedback-form"
        >
          <el-form-item label="电话" prop="phone">
            <el-input 
              v-model="feedbackForm.phone" 
              placeholder="请输入您的联系电话（可选）"
              maxlength="20"
            />
          </el-form-item>

          <el-form-item label="邮箱" prop="email">
            <el-input 
              v-model="feedbackForm.email" 
              placeholder="请输入您的电子邮箱（可选）"
              maxlength="50"
            />
          </el-form-item>

          <el-form-item label="留言" prop="message">
            <el-input
              v-model="feedbackForm.message"
              type="textarea"
              :rows="6"
              placeholder="请输入您的宝贵意见或建议（必填）"
              maxlength="500"
              show-word-limit
            />
          </el-form-item>

          <el-form-item>
            <el-button 
              type="primary" 
              size="large" 
              @click="submitFeedback"
              :loading="submitting"
              class="submit-btn"
            >
              提交反馈
            </el-button>
            <el-button size="large" @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- Contact Info -->
      <div class="contact-info">
        <h3>其他联系方式</h3>
        <div class="contact-items">
          <div class="contact-item">
            <el-icon><Message /></el-icon>
            <span>客服邮箱：softdown51@outlook.com</span>
          </div>
          <!-- <div class="contact-item">
            <el-icon><Phone /></el-icon>
            <span>客服电话：400-123-4567</span>
          </div> -->
          <div class="contact-item">
            <el-icon><Clock /></el-icon>
            <span>工作时间：周一至周五 9:00-18:00</span>
          </div>
          <div class="contact-item">
            <el-icon><ChatDotRound /></el-icon>
            <span>企业微信：</span>
            <a href="https://work.weixin.qq.com/kfid/kfc8d0f9bc2d1044192" target="_blank" rel="noopener noreferrer" class="wechat-link">
              点击联系客服
            </a>
          </div>
        </div>
        
        <!-- 微信二维码 -->
        <div class="qrcode-section">
          <div class="qrcode-container">
            <img src="@/assets/wechat.png" alt="企业微信二维码" class="qrcode-image" />
            <p class="qrcode-text">扫描二维码添加企业微信</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <el-footer class="footer">
      <div class="footer-content">
        <p class="copyright">Copyright©2026 51softdown.cn All rights reserved.</p>
        <div class="footer-links">
          <span>信阳市平桥区奇安科技有限公司贵州分公司</span>
          <span>黔ICP备2026000902号</span>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
//import { Message, Phone, Clock } from '@element-plus/icons-vue'
import { Message, Clock, ChatDotRound } from '@element-plus/icons-vue'
import { feedbackUrl } from '@/utils/api'

// 路由相关
const route = useRoute()
const router = useRouter()

// 表单数据
const feedbackForm = reactive({
  phone: '',
  email: '',
  message: ''
})

// 表单验证规则
const rules = {
  phone: [
    { pattern: /^1[3-9]\d{9}$|^$/, message: '请输入正确的手机号码', trigger: 'blur' }
  ],
  email: [
    { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$|^$/, message: '请输入正确的邮箱地址', trigger: 'blur' }
  ],
  message: [
    { required: true, message: '请输入留言内容', trigger: 'blur' },
    { min: 10, message: '留言内容至少10个字符', trigger: 'blur' }
  ]
}

// 提交状态
const submitting = ref(false)
const feedbackFormRef = ref(null)

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  if (route.path === '/order-query') {
    return '/order-query'
  } else if (route.path === '/about') {
    return '/about'
  } else if (route.path === '/idm') {
    return '/idm'
  } else if (route.path === '/idmpro') {
    return '/idmpro'
  } else if (route.path === '/feedback') {
    return '/feedback'
  }
  return '/'
})

// 菜单选择处理
const handleMenuSelect = (key) => {
  if (key === '/') {
    router.push('/')
  } else if (key === '/idm') {
    router.push('/idm')
  } else if (key === '/order-query') {
    router.push('/order-query')
  } else if (key === '/about') {
    router.push('/about')
  } else if (key === '/feedback') {
    router.push('/feedback')
  }
}

// 返回首页
const goHome = () => {
  router.push('/')
}

// 提交反馈
const submitFeedback = async () => {
  if (!feedbackFormRef.value) return
  
  try {
    const valid = await feedbackFormRef.value.validate()
    if (!valid) return
    
    submitting.value = true
    
    // 调用后端API提交反馈
    const response = await fetch(feedbackUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phone: feedbackForm.phone,
        email: feedbackForm.email,
        message: feedbackForm.message
      })
    })

    const result = await response.json()

    if (result.code === 0) {
      // 发送Umami自定义事件 - 意见反馈
      if (window.umami) {
        window.umami.track('user-feedback', {
          type: 'feedback',
          phone: feedbackForm.phone || '未提供',
          email: feedbackForm.email || '未提供',
          message_length: feedbackForm.message.length,
          timestamp: new Date().toISOString()
        })
      }
      
      ElMessage.success('感谢您的反馈！我们会尽快处理您的意见。')
      
      // 重置表单
      resetForm()
    } else {
      ElMessage.error('提交失败：' + result.msg)
    }
    
  } catch (error) {
    console.error('提交反馈失败:', error)
    ElMessage.error('网络错误，请稍后重试')
  } finally {
    submitting.value = false
  }
}

// 重置表单
const resetForm = () => {
  if (feedbackFormRef.value) {
    feedbackFormRef.value.resetFields()
  }
}

onMounted(() => {
  // 设置页面标题和 favicon
  document.title = '51软件下载 - 意见反馈'
  let favicon = document.querySelector('link[rel="icon"]')
  if (favicon) {
    favicon.href = '/favicon.ico'
  } else {
    // 如果页面中没有 favicon link 标签，则创建一个
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.href = '/favicon.ico'
    document.head.appendChild(favicon)
  }
})
</script>

<style scoped>
.feedback-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
}

/* Header Styles */
.header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-menu {
  border: none;
  background: transparent !important;
}

.nav-menu .el-menu-item {
  font-weight: 500;
  padding: 0 20px;
}

/* Main Content */
.feedback-container {
  flex: 1;
  width: 800px;
  margin: 40px auto;
  padding: 0 20px;
}

.feedback-card {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.feedback-header {
  text-align: center;
  margin-bottom: 40px;
}

.feedback-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}

.feedback-subtitle {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.feedback-form {
  margin-top: 30px;
}

.submit-btn {
  width: 120px;
  margin-right: 15px;
}

/* Contact Info */
.contact-info {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  padding: 30px;
  text-align: center;
}

.contact-info h3 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.contact-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 16px;
  color: #666;
}

.contact-item .el-icon {
  color: #1890ff;
}

.wechat-link {
  color: #07c160;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
}

.wechat-link:hover {
  color: #06a952;
  text-decoration: underline;
}

.qrcode-section {
  margin-top: 25px;
  padding-top: 25px;
  border-top: 1px solid #e8e8e8;
}

.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.qrcode-image:hover {
  transform: scale(1.05);
}

.qrcode-text {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* Footer */
.footer {
  background: rgba(0, 0, 0, 0.8);
  color: white;
  text-align: center;
  padding: 20px 0;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

.copyright {
  font-size: 14px;
  margin-bottom: 10px;
}

.footer-links {
  font-size: 12px;
  color: #ccc;
}

.footer-links span {
  margin: 0 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .feedback-container {
    margin: 20px auto;
    padding: 0 15px;
  }
  
  .feedback-card {
    padding: 30px 20px;
  }
  
  .feedback-title {
    font-size: 24px;
  }
  
  .header-content {
    padding: 0 15px;
  }
  
  .nav-menu .el-menu-item {
    padding: 0 10px;
    font-size: 14px;
  }
}
</style>